import NewSearchButton from './NewSearchButton';

export default NewSearchButton;
